<!-- Modal de Atestados Médicos -->
<div
  *ngIf="personName"
  class="modal fade"
  id="abstinencesModal"
  tabindex="-1"
  aria-labelledby="abstinencesModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-info">
            <h2 class="modal-title">Atestados Médicos</h2>
            <div class="employee-info">
              <div class="employee-details">
                <span class="employee-name">{{ personName }}</span>
                <span class="employee-role">Funcionário</span>
              </div>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>
      <div class="modal-body">
        <div class="summary-info">
          <p class="summary-text">Histórico de atestados médicos registrados</p>
          <div class="stats-container">
            <div class="stat-item">
              <span class="stat-number">{{ abstinences.length }}</span>
              <span class="stat-label">Total de Atestados</span>
            </div>
          </div>
        </div>

        <!-- Tabela de Atestados - Mostra apenas quando há atestados -->
        <div class="mt-md-0 mt-sm-4 abstinence-modal" *ngIf="abstinences.length > 0">
          <mat-table [dataSource]="abstinences">
            <!-- Coluna Descrição -->
            <ng-container matColumnDef="description">
              <mat-header-cell *matHeaderCellDef>Descrição</mat-header-cell>
              <mat-cell *matCellDef="let abstinence">{{ abstinence.description }}</mat-cell>
            </ng-container>

            <!-- Coluna Data de Início -->
            <ng-container matColumnDef="startDate">
              <mat-header-cell *matHeaderCellDef>Início</mat-header-cell>
              <mat-cell *matCellDef="let abstinence">{{ formatDate(abstinence.startDate) }}</mat-cell>
            </ng-container>

            <!-- Coluna Data de Fim -->
            <ng-container matColumnDef="endDate">
              <mat-header-cell *matHeaderCellDef>Fim</mat-header-cell>
              <mat-cell *matCellDef="let abstinence">{{ formatDate(abstinence.endDate) }}</mat-cell>
            </ng-container>

            <!-- Coluna Documento -->
            <ng-container matColumnDef="document">
              <mat-header-cell *matHeaderCellDef>Documento</mat-header-cell>
              <mat-cell *matCellDef="let abstinence">
                <button *ngIf="hasDocument(abstinence)" (click)="openDocument(abstinence)" class="document-button">
                  Visualizar
                </button>
                <span *ngIf="!hasDocument(abstinence)" class="no-document"> Indisponível </span>
              </mat-cell>
            </ng-container>

            <!-- Coluna Ações -->
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>Ações</mat-header-cell>
              <mat-cell *matCellDef="let abstinence">
                <div class="action-buttons">
                  <button (click)="onEdit(abstinence)" class="action-edit" title="Editar atestado">✏️</button>
                  <button (click)="onDelete(abstinence.id!)" class="action-delete" title="Excluir atestado">🗑️</button>
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>

        <!-- Estado Vazio Melhorado -->
        <div class="empty-state-container" *ngIf="abstinences.length == 0">
          <div class="empty-state-content">
            <div class="empty-icon-wrapper">
              <mat-icon class="empty-icon">medical_services</mat-icon>
            </div>
            <h3 class="empty-title">Nenhum atestado médico cadastrado</h3>
            <p class="empty-description">
              Não há atestados médicos registrados para este funcionário.
              <br />
              Clique no botão "Cadastrar" para adicionar o primeiro atestado.
            </p>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Fechar</button>
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" (click)="onCreate()">Cadastrar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Criação/Edição de Atestados -->
<div
  *ngIf="personName"
  class="modal fade"
  id="abstinencesCreateModal"
  tabindex="-1"
  aria-labelledby="abstinencesCreateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-info">
            <h2 class="modal-title">Cadastrar Atestado Médico</h2>
            <div class="employee-info">
              <div class="employee-details">
                <span class="employee-name">{{ personName }}</span>
                <span class="employee-role">Funcionário</span>
              </div>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>
      <div class="modal-body">
        <div class="summary-info">
          <p class="summary-text">Preencha os dados do atestado médico</p>
        </div>

        <form [formGroup]="formAbstinence" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="abstinenceStartDate" class="form-label">Data de Início</label>
              <input type="date" class="form-control" id="abstinenceStartDate" formControlName="startDate" />
            </div>
            <div class="col-md-6 mb-3">
              <label for="abstinenceEndDate" class="form-label">Data de Fim</label>
              <input type="date" class="form-control" id="abstinenceEndDate" formControlName="endDate" />
            </div>
            <div class="mb-3">
              <label for="description" class="form-label">Observação</label>
              <textarea
                class="form-control"
                id="description"
                rows="5"
                formControlName="description"
                placeholder="Digite a observação"
              ></textarea>
              <div *ngIf="abstinenceDescription?.errors?.maxlength">
                Máximo de letras excedido! Por favor, o limite de letras é de {{ maxLength }}.
              </div>
              <div>Letras restantes: {{ remainingCharacters }}</div>
            </div>
            <div class="mb-3">
              <label for="document" class="form-label">Documento</label>
              <input
                type="file"
                id="document"
                formControlName="document"
                class="form-control"
                (change)="onFileSelected($event)"
              />
            </div>
          </div>
          <button *ngIf="!isSaving" [disabled]="formAbstinence.invalid" type="submit" class="btn btn-primary w-100">
            Salvar
          </button>
        </form>
        <div *ngIf="isSaving" class="spinner-container">
          <div class="spinner"></div>
        </div>
      </div>
    </div>
  </div>
</div>
